import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackCTAClick } from "@/utils/analytics";

const priceFeatures = [
  "5 full days of fencing sessions",
  "All equipment included",
  "Expert coaching",
  "Masky Fencing Passport",
  "Valid 12 months from purchase",
  "Total flexibility — mix & match",
  "Childcare vouchers & Tax-Free Childcare accepted",
];

export default function PricingSection() {
  const openJotform = () => {
    trackCTAClick("Pricing — Get Your Pass");
    window.open("https://pci.jotform.com/form/260353574059056", "_blank");
  };

  return (
    <section
      id="pricing"
      className="py-20 bg-[#F4F4F4]"
      data-testid="pricing-section"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#D4A857]/10 text-[#D4A857] px-4 py-2 rounded text-sm font-bold uppercase tracking-wide mb-4 font-['Montserrat']">
            Amazing Value
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0A1A2F] mb-4 font-['Montserrat']">
            One Pass. Five Days. <span className="text-[#D4A857]">Total Flexibility.</span>
          </h2>
        </div>

        {/* Pricing Card */}
        <div className="bg-white rounded-lg shadow-2xl overflow-hidden border-4 border-[#D4A857]/20 relative">
          {/* Masky - Small */}
          <div className="absolute -top-2 -right-2 z-10">
            <img
              src="https://customer-assets.emergentagent.com/job_1abea0ec-cded-4678-a29f-de28c813ea65/artifacts/2pfnnew9_bigger%20masky.png"
              alt="Masky celebrating"
              className="w-36"
            />
          </div>
          
          {/* Header */}
          <div className="bg-[#0A1A2F] p-8 text-white text-center">
            <p className="text-[#D4A857] font-bold mb-2 font-['Montserrat'] uppercase tracking-wide">5-Day Fencing Pass</p>
            <div className="flex items-center justify-center gap-2">
              <span className="text-6xl font-extrabold font-['Montserrat']">£99</span>
            </div>
            <p className="text-white/70 mt-2 font-['Lato']">per child • Valid 12 months from purchase</p>
          </div>
          
          {/* Features */}
          <div className="p-8">
            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              {priceFeatures.map((feature, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-[#D4A857] rounded-full flex items-center justify-center flex-shrink-0">
                    <Check size={14} className="text-[#0A1A2F]" />
                  </div>
                  <span className="text-[#0A1A2F] font-medium font-['Lato']">{feature}</span>
                </div>
              ))}
            </div>
            
            {/* CTA */}
            <Button
              onClick={openJotform}
              size="lg"
              className="w-full bg-[#D4A857] hover:bg-[#C49A4D] text-[#0A1A2F] font-bold text-xl py-7 rounded shadow-lg hover:shadow-xl transition-all font-['Montserrat'] uppercase tracking-wide"
              data-testid="pricing-cta-button"
            >
              Get Your 5-Day Pass
            </Button>
            
            <p className="text-center text-gray-500 text-sm mt-4 font-['Lato']">
              Secure your spot today • Places are limited
            </p>
          </div>
        </div>

        {/* Value Breakdown */}
        <div className="mt-8 text-center">
          <p className="text-gray-600 font-['Lato']">
            That's just <span className="font-bold text-[#D4A857] text-xl">£19.80 per day</span> for a full day of expert coaching, 
            all equipment, and an unforgettable experience!
          </p>
        </div>
      </div>
    </section>
  );
}
